import { combineReducers } from 'redux'
import { DEFAULT_PAGINATION_ENTRIES } from 'services/api'
import { getType } from 'typesafe-actions'

import {
  closePersonForm,
  openNewPersonForm,
  openPersonForm,
  PeopleManagerAction,
  resetSearch,
  selectPerson,
  updateCurrentPage,
  updateSearch,
} from './actions'
import { PeopleManagerState } from './types'

export const peopleManagerReducer = combineReducers<PeopleManagerState, PeopleManagerAction>({
  currentPage: (currentPage = 0, action) => {
    switch (action.type) {
      case getType(updateCurrentPage):
        return action.payload.nextPage
      case getType(updateSearch):
      case getType(resetSearch):
        return 0
      default:
        return currentPage
    }
  },
  limit: (limit = DEFAULT_PAGINATION_ENTRIES, action) => {
    switch (action.type) {
      default:
        return limit
    }
  },
  search: (search = '', action) => {
    switch (action.type) {
      case getType(updateSearch):
        return action.payload.search
      case getType(resetSearch):
        return ''
      default:
        return search
    }
  },
  selectedPersonId: (selectedPersonId = null, action) => {
    switch (action.type) {
      case getType(openNewPersonForm):
        return null
      case getType(openPersonForm):
      case getType(selectPerson):
        return action.payload.personId
      default:
        return selectedPersonId
    }
  },
  personFormOpen: (formOpen = false, action) => {
    switch (action.type) {
      case getType(openNewPersonForm):
        return true
      case getType(openPersonForm):
        return true
      case getType(closePersonForm):
        return false
      default:
        return formOpen
    }
  },
})
